import Vue from 'vue'
import VueRouter, {
	RouteConfig
} from 'vue-router'
import Layout from '@/views/layout/layout.vue'

Vue.use(VueRouter)

export const constantRoutes: RouteConfig[] = [{
	path: '/login',
	component: () => import('@/views/login/index.vue'),
	meta: {
		hidden: true,
	}
}, {
	path: '/',
	component: Layout,
	redirect: '/home/index',
	name: '主页',
	meta: {
		hidden: true
	}
}]

export const asyncRoutes: RouteConfig[] = [{
	path: '/home',
	component: Layout,
	name: 'p_home',
	children: [{
		path: 'index',
		name: 'Home',
		component: () => import('@/views/home/index.vue'),
		meta: {
			title: '首页',
			icon: 'home',
			type: 'single'
		}
	}]
}, {
	path: '/product',
	component: Layout,
	name: 'p_product',
	meta: {
		title: '商品管理',
		icon: 'product'
	},
	children: [{
		path: 'list',
		name: 'Product_List',
		component: () => import('@/views/product/list.vue'),
		meta: {
			title: '商品库',
			keepAlive: true
		}
	},
	{
		path: 'activity-detail',
		name: 'Activity_Detail',
		component: () => import('@/views/operation/activity_detail.vue'),
		meta: {
			title: '活动配置',
			hidden: true
		}
	},
	{
		path: 'category',
		name: 'Product_Category',
		component: () => import('@/views/product/category.vue'),
		meta: {
			title: '商品分类',
			// hidden: true
		}
	},
	{
		path: 'classificationManagement',
		name: 'classificationManagement',
		component: () => import('@/views/product/classificationManagement/index.vue'),
		meta: {
			title: '商品类目'
		}
	},
	{
		path: 'secondClass',
		name: 'secondClass',
		component: () => import('@/views/product/classificationManagement/secondClass.vue'),
		meta: {
			title: '商品类目',
			hidden: true
		}
	},
	{
		path: 'thirdClass',
		name: 'thirdClass',
		component: () => import('@/views/product/classificationManagement/thirdClass.vue'),
		meta: {
			title: '商品类目',
			hidden: true
		}
	},
	{
		path: 'categorychild',
		name: 'Product_Category_Child',
		component: () => import('@/views/product/category-child.vue'),
		meta: {
			title: '编辑分类',
			hidden: true
		}
	}, {
		path: 'selfOwnedBrand',
		name: 'selfOwnedBrand',
		component: () => import('@/views/product/selfOwnedBrand/index.vue'),
		meta: {
			title: '自营品牌管理',
			keepAlive: true
		}
	}, {
		path: 'selfOwnedBrandShopManage',
		name: 'selfOwnedBrandShopManage',
		component: () => import('@/views/product/selfOwnedBrand/shopManage.vue'),
		meta: {
			title: '自营品牌管理',
			hidden: true,
		}
	}, {
		path: 'inventoryrecord',
		name: 'inventoryrecord',
		component: () => import('@/views/product/inventoryrecord.vue'),
		meta: {
			title: '库存变动记录',
			// keepAlive: true
		}
	},
	//  {
	// 	path: 'check',
	// 	name: 'Product_Check',
	// 	component: () => import('@/views/product/supplier-check.vue'),
	// 	meta: {
	// 		title: '供应商商品审核',
	// 		keepAlive: true
	// 	}
	// },{
	// 	path: 'checkdetail',
	// 	name: 'Product_checkdetail',
	// 	component: () => import('@/views/product/supplier-checkdetail.vue'),
	// 	meta: {
	// 		title: '供应商商品审核详情',
	// 		hidden:true
	// 	}
	// }, 
	{
		path: 'sales',
		name: 'Product_Sales',
		component: () => import('@/views/product/sales.vue'),
		meta: {
			title: '商品销量统计',
			// keepAlive: true
		}
	},
	// {
	// 	path: 'repeat',
	// 	name: 'Product_Repeat',
	// 	component: () => import('@/views/product/repeat-buy.vue'),
	// 	meta: {
	// 		title: '复购申请记录'
	// 	}
	// }, 
	{
		path: 'history',
		name: 'Product_History',
		component: () => import('@/views/product/buy-history.vue'),
		meta: {
			title: '销售记录',
			hidden: true
		}
	}, {
		path: 'record',
		name: 'Product_History_Record',
		component: () => import('@/views/product/sales-record.vue'),
		meta: {
			title: '往期售卖记录',
			hidden: true
		}
	}, {
		path: 'rank',
		name: 'Product_Rank',
		component: () => import('@/views/product/rank.vue'),
		meta: {
			title: '销售排行',
			hidden: true
		}
	}, {
		path: 'product-detail',
		name: 'Product_Detail',
		component: () => import('@/views/product/product_detail.vue'),
		meta: {
			title: '商品信息',
			hidden: true
		}
	}, {
		path: 'product-material',
		name: 'product-material',
		component: () => import('@/views/product/product-material.vue'),
		meta: {
			title: '商品素材',
			hidden: true
		}
	}, {
		path: 'product-material-detail',
		name: 'product-material-detail',
		component: () => import('@/views/product/product-material-detail.vue'),
		meta: {
			title: '编辑素材',
			hidden: true
		}
	}, {
		path: 'Aftergroup',
		name: 'Aftergroup',
		component: () => import('@/views/product/Aftergroup.vue'),
		meta: {
			title: '复团申请记录',
		}
	}, {
		path: 'makeWish',
		name: 'makeWish',
		component: () => import('@/views/product/makeWish.vue'),
		meta: {
			title: '许愿商品',
		}
	}, {
		path: 'settleFreight',
		name: 'settleFreight',
		component: () => import('@/views/product/settleFreight/index.vue'),
		meta: {
			title: '结算运费',
			hidden: true
		}
	}, {
		path: 'settleFreightRecord',
		name: 'settleFreightRecord',
		component: () => import('@/views/product/settleFreight/record.vue'),
		meta: {
			title: '修改记录',
			hidden: true
		}
	}, {
		path: 'setSupplyPrice',
		name: 'setSupplyPrice',
		component: () => import('@/views/product/settleFreight/setSupplyPrice.vue'),
		meta: {
			title: '商品结算规则',
			hidden: true
		}
	}, {
		path: 'purchasePersonnel',
		name: 'purchasePersonnel',
		component: () => import('@/views/product/purchasePersonnel/index.vue'),
		meta: {
			title: '采购人员管理'
		}
	},
	{
		path: 'auditScheduleShop',
		name: 'auditScheduleShop',
		component: () => import('@/views/product/auditScheduleShop/index.vue'),
		meta: {
			title: '审核排期商品',
			keepAlive: true
		}
	},
	{
		path: 'auditScheduleShopDetails',
		name: 'auditScheduleShopDetails',
		component: () => import('@/views/product/auditScheduleShop/shopDetails.vue'),
		meta: {
			title: '商品信息',
			hidden: true,
		}
	},
	]
}, {
	path: '/order',
	component: Layout,
	name: 'p_order',
	meta: {
		title: '订单管理',
		icon: 'order'
	},
	children: [{
		path: 'list',
		name: 'Order_List',
		component: () => import('@/views/order/list.vue'),
		meta: {
			title: '订单查询',
			keepAlive: true
		}
	}, 
	{
		path: 'product',
		name: 'Order_Product',
		component: () => import('@/views/order/product.vue'),
		meta: {
			title: '产品订单',
			keepAlive: true
		}
	}, 
	 {
		path: 'logisticsbroadcast',
		name: 'logisticsbroadcast',
		component: () => import('@/views/order/logisticsbroadcast.vue'),
		meta: {
			title: '物流播报',
			// keepAlive: true
		}
	},
	{
		path: 'deliverymanagement',
		name: 'deliverymanagement',
		component: () => import('@/views/order/deliverymanagement/index.vue'),
		meta: {
			title: '产品发货管理',
			keepAlive: true
		}
	},
	{
		path: 'shopSettlement',
		name: 'shopSettlement',
		component: () => import('@/views/order/shopSettlement/index.vue'),
		meta: {
			title: '商品结算',
		}
	},
	{
		path: 'netIncome',
		name: 'netIncome',
		component: () => import('@/views/order/netIncome.vue'),
		meta: {
			title: '净额收入',
		}
	},
	{
		path: 'singleorderAdd',
		name: 'singleorderAdd',
		component: () => import('@/views/order/singleorderAdd/index.vue'),
		meta: {
			title: '散单加单',
		}
	},
	{
		path: 'importOrder',
		name: 'importOrder',
		component: () => import('@/views/order/importOrder/index.vue'),
		meta: {
			title: '导入订单',
		}
	},
	{
		path: 'shopDailyConsumptionStatistics',
		name: 'shopDailyConsumptionStatistics',
		component: () => import('@/views/order/shopDailyConsumptionStatistics/index.vue'),
		meta: {
			title: '商品日常消耗统计',
		}
	},
	{
		path: 'merchantexportrecord',
		name: 'merchantexportrecord',
		component: () => import('@/views/order/merchantexportrecord.vue'),
		meta: {
			title: '商家结算导出记录',
		}
	},
	{
		path: 'parent-record',
		name: 'Check_Record',
		component: () => import('@/views/order/check_record.vue'),
		meta: {
			title: '审核记录',
			keepAlive: true
		}
	}, 
	{
		path: 'logisticstracking',
		name: 'logisticstracking',
		component: () => import('@/views/order/logisticstracking.vue'),
		meta: {
			title: '物流跟踪',
		}
	},
	// {
	// 	path: 'agency',
	// 	name: 'Order_Agency',
	// 	component: () => import('@/views/order/agency.vue'),
	// 	meta: {
	// 		title: '代理订单',
	// 		keepAlive: true
	// 	}
	// }, 
	{
		path: 'agency-check',
		name: 'Agency_Check',
		component: () => import('@/views/order/agency_check-order.vue'),
		meta: {
			title: '审核订单',
			hidden: true,
			// keepAlive: true
		}
	}, {
		path: 'agency-check-record',
		name: 'Agency_Check_Record',
		component: () => import('@/views/order/agency_check-record.vue'),
		meta: {
			title: '审核记录',
			hidden: true
		}
	}, {
		path: 'agency-check-record-detail',
		name: 'Agency_Check_Record_Detail',
		component: () => import('@/views/order/agency_check-record-detail.vue'),
		meta: {
			title: '审核记录详情',
			hidden: true
		}
	}, {
		path: 'agency-product-record',
		name: 'Agency_Product_Record',
		component: () => import('@/views/order/agency_product-record.vue'),
		meta: {
			title: '产品记录',
			hidden: true
		}
	}, {
		path: 'order-product-detail',
		name: 'Order_Product_detail',
		component: () => import('@/views/order/product_detail.vue'),
		meta: {
			title: '查看详情',
			hidden: true,
			keepAlive: true
		}
	}, {
		path: 'order-detail',
		name: 'Order_Detail',
		component: () => import('@/views/order/detail.vue'),
		meta: {
			title: '订单详情',
			hidden: true
		}
	}, {
		path: 'order-aftersales',
		name: 'Order_Aftersales',
		component: () => import('@/views/order/aftersales.vue'),
		meta: {
			title: '售后申请',
			hidden: true
		}
	}, 
	
	{
		path: 'paydetail',
		name: 'paydetail',
		component: () => import('@/views/order/paydetail.vue'),
		meta: {
			//审核记录 已支付订单详情
			title: '订单详情',
			hidden: true
		}
	}, {
		path: 'deliverymanagement_exportrecord',
		name: 'deliverymanagement_exportrecord',
		component: () => import('@/views/order/deliverymanagement/exportrecord.vue'),
		meta: {
			title: '导出记录',
			hidden: true,
		}
	}, {
		path: 'deliverymanagement_detail',
		name: 'deliverymanagement_detail',
		component: () => import('@/views/order/deliverymanagement/detail.vue'),
		meta: {
			title: '查看详情',
			hidden: true,
		}
	}, {
		path: 'batchbeshipped',
		name: 'batchbeshipped',
		component: () => import('@/views/order/deliverymanagement/batchbeshipped.vue'),
		meta: {
			title: '批量返回待发货',
			hidden: true,
		}
	},
	
	
	
	{
		path: 'generate',
		name: 'generate',
		component: () => import('@/views/order/singleorderAdd/generate.vue'),
		meta: {
			title: '散单加单',
			hidden: true
		}
	},
	{
		path: 'dailyAnalysis',
		name: 'dailyAnalysis',
		component: () => import('@/views/order/dailyAnalysis/index.vue'),
		meta: {
			title: '每日分析',
		}
	},
	
	
	
	]
},
{
	path: '/aftersales',
	component: Layout,
	name: 'p_aftersales',
	meta: {
		title: '售后管理',
		icon: 'aftersales'
	},
	children: [{
		path: 'list',
		name: 'After_List',
		component: () => import('@/views/aftersales/order.vue'),
		meta: {
			title: '售后单管理',
			keepAlive: true
		}
	},
	{
		path: '/aftersales/freightCompensationStatistical',
		name: 'freightCompensationStatistical',
		component: () => import('@/views/aftersales/freightCompensationStatistical.vue'),
		meta: {
			title: '退换无忧赔付统计',
			hidden: true
		}
	},
	{
		path: '/aftersales/detail',
		name: 'After_Detail',
		component: () => import('@/views/aftersales/detail.vue'),
		meta: {
			title: '售后详情',
			hidden: true
		}
	},
	{
		path: 'memberstatistical/list',
		name: 'memberstatistical',
		component: () => import('@/views/aftersales/memberstatistical/list.vue'),
		meta: {
			title: '分销员售后统计',
			keepAlive: true
		}
	},
	{
		path: 'memberstatistical/detail',
		name: 'memberstatistical_detail',
		component: () => import('@/views/aftersales/memberstatistical/detail.vue'),
		meta: {
			title: '分销员售后统计',
			hidden: true,
			keepAlive: true
		}
	},
	{
		path: 'shopStatistical/list',
		name: 'shopStatistical',
		component: () => import('@/views/aftersales/shopStatistical/list.vue'),
		meta: {
			title: '商品售后统计',
			keepAlive: true
		}
	},
	{
		path: 'shopStatistical/detail',
		name: 'shopStatistical_detail',
		component: () => import('@/views/aftersales/shopStatistical/detail.vue'),
		meta: {
			title: '商品售后统计',
			hidden: true,
			keepAlive: true
		}
	},
	{
		path: 'remindReceive',
		name: 'remindReceive',
		component: () => import('@/views/aftersales/remindReceive.vue'),
		meta: {
			title: '物流信息提醒',
			hidden: true,
		}
	},
	]
},
{
	path: '/supplier',
	component: Layout,
	name: 'p_supplier',
	meta: {
		title: '供应商管理',
		icon: 'supplier'
	},
	children: [{
		path: 'list',
		name: 'Supplier_List',
		component: () => import('@/views/supplier/list.vue'),
		meta: {
			title: '供应商列表',
			keepAlive: true
		}
	}, {
		path: 'banklist',
		name: 'banklist',
		component: () => import('@/views/supplier/banklist.vue'),
		meta: {
			title: '商家收款银行管理',
			hidden: true
		}
	}, {
		path: 'seterp',
		name: 'seterp',
		component: () => import('@/views/supplier/seterp.vue'),
		meta: {
			title: 'erp对接设置',
			hidden: true
		}
	}, {
		path: 'data',
		name: 'Supplier_Data',
		component: () => import('@/views/supplier/data.vue'),
		meta: {
			title: '供应商统计',
			keepAlive: true
		}
	},
	// {
	// 	path: 'after',
	// 	name: 'Supplier_After',
	// 	component: () => import('@/views/supplier/after.vue'),
	// 	meta: {
	// 		title: '供应商售后统计'
	// 	}
	// }, 
	{
		path: 'detail',
		name: 'Supplier_Detail',
		component: () => import('@/views/supplier/detail.vue'),
		meta: {
			title: '供应商信息',
			hidden: true
		}
	}, {
		path: 'data-detail',
		name: 'Supplier_Date_Detail',
		component: () => import('@/views/supplier/data_detail.vue'),
		meta: {
			title: '统计详情',
			hidden: true
		}
	}, {
		path: 'after-detail',
		name: 'Supplier_After_Detail',
		component: () => import('@/views/supplier/after_detail.vue'),
		meta: {
			title: '售后详情',
			hidden: true
		}
	}, {
		path: 'template',
		name: 'Logistics_Template',
		component: () => import('@/views/logistics/template.vue'),
		meta: {
			title: '物流模板'
		}
	}, {
		path: 'desc',
		name: 'Desc_List',
		component: () => import('@/views/logistics/desc_list.vue'),
		meta: {
			title: '供应商物流模版',
			hidden: true
		}
	}, {
		path: 'logisticsdetail',
		name: 'Template_Detail',
		component: () => import('@/views/logistics/detail.vue'),
		meta: {
			title: '物流模版',
			hidden: true
		}
	}]
}, {
	path: '/member',
	component: Layout,
	name: 'p_member',
	meta: {
		title: '分销员管理',
		icon: 'member'
	},
	children: [{
		path: 'list',
		name: 'Member_List',
		component: () => import('@/views/member/list.vue'),
		meta: {
			title: '分销员列表',
			keepAlive: true
		}
	}, {
		path: 'detail',
		name: 'Member_Detail',
		component: () => import('@/views/member/member_detail.vue'),
		meta: {
			title: '编辑',
			hidden: true
		}
	}, {
		path: 'add',
		name: 'add_member',
		component: () => import('@/views/member/add_member.vue'),
		meta: {
			title: '添加',
			hidden: true
		}
	},
	{
		path: 'LabelManagement',
		name: 'LabelManagement',
		component: () => import('@/views/member/LabelManagement/index.vue'),
		meta: {
			title: '分销员标签管理'
		}
	}, {
		path: 'LabelManagementDetails',
		name: 'LabelManagementDetails',
		component: () => import('@/views/member/LabelManagement/details.vue'),
		meta: {
			title: '标签详情',
			hidden: true
		}
	}, {
		path: 'performance',
		name: 'Member_Performance',
		component: () => import('@/views/member/performance.vue'),
		meta: {
			title: '分销员业绩统计',
			keepAlive: true
		}
	}, {
		path: 'performance-desc',
		name: 'Member_Performance_Desc',
		component: () => import('@/views/member/performance-desc.vue'),
		meta: {
			title: '分销员业绩统计详情',
			hidden: true
		}
	}, {
		path: 'team',
		name: 'Member_Team',
		component: () => import('@/views/member/team.vue'),
		meta: {
			title: '团队业绩统计',
			hidden: true
		}
	}, {
		path: 'prize',
		name: 'Member_Prize',
		component: () => import('@/views/member/prize.vue'),
		meta: {
			title: '业绩奖励列表',
			hidden: true
		}
	}, {
		path: 'customer-statistic',
		name: 'customer-statistic',
		component: () => import('@/views/member/customer-statistic/customer-statistic.vue'),
		meta: {
			title: '访问&客户下单'
		}
	}, {
		path: 'customer-order-statistic',
		name: 'customer-order-statistic',
		component: () => import('@/views/member/customer-order-statistic/customer-order-statistic.vue'),
		meta: {
			title: '客户订单分布'
		}
	}, {
		path: 'profit-statistic',
		name: 'profit-statistic',
		component: () => import('@/views/member/profit-statistic/profit-statistic.vue'),
		meta: {
			title: '利润统计',
			keepAlive: true
		}
	}, {
		path: 'profit-statistic-detail',
		name: 'profit-statistic-detail',
		component: () => import('@/views/member/profit-statistic/detail.vue'),
		meta: {
			title: '利润统计详情',
			hidden: true
		}
	}, {
		path: 'base-performance',
		name: 'Base_Performance',
		component: () => import('@/views/member/base_performance.vue'),
		meta: {
			title: '业绩统计',
			keepAlive: true
		}
	}, {
		path: 'base-performance-importrecord',
		name: 'Base_Performance-importrecord',
		component: () => import('@/views/member/importrecord.vue'),
		meta: {
			title: '导入记录',
			hidden: true
		}
	}, {
		path: 'recommendPerformanceStatistics',
		name: 'recommendPerformanceStatistics',
		component: () => import('@/views/member/recommendPerformanceStatistics/index.vue'),
		meta: {
			title: '推荐业绩统计'
		}
	}, {
		path: 'shoppingAllowanceDetail',
		name: 'shoppingAllowanceDetail',
		component: () => import('@/views/member/shoppingAllowanceDetail/index.vue'),
		meta: {
			title: '购物金明细'
		}
	},
	{
		path: 'UserCredit',
		name: 'UserCredit',
		component: () => import('@/views/member/UserCredit/index.vue'),
		meta: {
			title: '用户积分'
		}
	},
	{
		path: 'invitationCodeStatistics',
		name: 'invitationCodeStatistics',
		component: () => import('@/views/member/invitationCodeStatistics/index.vue'),
		meta: {
			title: '邀请码统计'
		}
	},
	{
		path: 'distributorChangeRecord',
		name: 'distributorChangeRecord',
		component: () => import('@/views/member/distributorChangeRecord.vue'),
		meta: {
			title: '变动记录'
		}
	},
	{
		path: 'shareRetailData',
		name: 'shareRetailData',
		component: () => import('@/views/member/shareRetailData/index.vue'),
		meta: {
			title: '分享零售数据'
		}
	},
	]
},
{
	path: '/financemanagement',
	component: Layout,
	name: 'p_financemanagement',
	meta: {
		title: '财务管理',
		icon: 'financemanagement'
	},
	children: [
		{
			path: 'withdrawcash',
			name: 'withdrawcash',
			component: () => import('@/views/financemanagement/withdrawcash.vue'),
			meta: {
				title: '提现管理'
			}
		},
		{
			path: 'shopsettle',
			name: 'shopsettle',
			component: () => import('@/views/financemanagement/shopsettle/index.vue'),
			meta: {
				title: '商品结算管理',
				keepAlive: true
			}
		},
		{
			path: 'settleDetails',
			name: 'settleDetails',
			component: () => import('@/views/financemanagement/shopsettle/settleDetails.vue'),
			meta: {
				title: '商品结算管理',
				hidden: true
			}
		},
		{
			path: 'orderDetails',
			name: 'orderDetails',
			component: () => import('@/views/financemanagement/shopsettle/orderDetails.vue'),
			meta: {
				title: '订单明细',
				hidden: true
			}
		},
		{
			path: 'aftersaleDetails',
			name: 'aftersaleDetails',
			component: () => import('@/views/financemanagement/shopsettle/aftersaleDetails.vue'),
			meta: {
				title: '售后明细',
				hidden: true
			}
		},
		{
			path: 'account',
			name: 'account',
			component: () => import('@/views/financemanagement/shopsettle/account.vue'),
			meta: {
				title: '结算账户',
				hidden: true
			}
		},
		{
			path: 'serviceContract',
			name: 'serviceContract',
			component: () => import('@/views/financemanagement/serviceContract/index.vue'),
			meta: {
				title: '服务合同发票',
				keepAlive: true
			}
		},
		{
			path: 'serviceContractDetail',
			name: 'serviceContractDetail',
			component: () => import('@/views/financemanagement/serviceContract/Detail.vue'),
			meta: {
				title: '服务合同发票',
				hidden: true
			}
		},
		{
			path: 'invoicemsg',
			name: 'invoicemsg',
			component: () => import('@/views/financemanagement/serviceContract/invoicemsg.vue'),
			meta: {
				title: '确认开票信息',
				hidden: true
			}
		},
		{
			path: 'purchasesaleContract',
			name: 'purchasesaleContract',
			component: () => import('@/views/financemanagement/purchasesaleContract/index.vue'),
			meta: {
				title: '购销合同发票',
				keepAlive: true
			}
		},
		{
			path: 'purchasesaleContractDetail',
			name: 'purchasesaleContractDetail',
			component: () => import('@/views/financemanagement/purchasesaleContract/Detail.vue'),
			meta: {
				title: '购销合同发票',
				hidden: true
			}
		},
		{
			path: 'importShoppingAmount',
			name: 'importShoppingAmount',
			component: () => import('@/views/financemanagement/importShoppingAmount/index.vue'),
			meta: {
				title: '导入购物金',
			}
		},
		{
			path: 'userInvoiceSchedule',
			name: 'userInvoiceSchedule',
			component: () => import('@/views/financemanagement/userInvoiceSchedule/index.vue'),
			meta: {
				title: '用户开票进度',
			}
		},
		{
			path: 'userInvoiceScheduleDetails',
			name: 'userInvoiceScheduleDetails',
			component: () => import('@/views/financemanagement/userInvoiceSchedule/details.vue'),
			meta: {
				title: '用户开票进度',
				hidden: true
			}
		},
		{
			path: 'userInvoiceScheduleDetailsData',
			name: 'userInvoiceScheduleDetailsData',
			component: () => import('@/views/financemanagement/userInvoiceSchedule/data.vue'),
			meta: {
				title: '用户开票进度',
				hidden: true
			}
		},
	]
},
{
	path: '/dataAnalysis',
	component: Layout,
	name: 'p_dataAnalysis',
	meta: {
		title: '数据分析',
		icon: 'dataAnalysis'
	},
	children: [
		{
			path: 'shopsalesAnalysis',
			name: 'shopsalesAnalysis',
			component: () => import('@/views/dataAnalysis/shopsalesAnalysis.vue'),
			meta: {
				title: '商品销售分析'
			}
		},
		{
			path: 'productSaleRank',
			name: 'productSaleRank',
			component: () => import('@/views/dataAnalysis/productSaleRank.vue'),
			meta: {
				title: '零售排行',
				hidden: true
			}
		},
		{
			path: 'tradingAnalysis',
			name: 'tradingAnalysis',
			component: () => import('@/views/dataAnalysis/tradingAnalysis.vue'),
			meta: {
				title: '交易分析'
			}
		},
		{
			path: 'userAnalysis',
			name: 'userAnalysis',
			component: () => import('@/views/dataAnalysis/userAnalysis.vue'),
			meta: {
				title: '用户分析'
			}
		},
		{
			path: 'teamAnalysis',
			name: 'teamAnalysis',
			component: () => import('@/views/dataAnalysis/teamAnalysis.vue'),
			meta: {
				title: '团队分析',
				keepAlive: true
			}
		},
		{
			path: 'detailTeam',
			name: 'detailTeam',
			component: () => import('@/views/dataAnalysis/detailTeam.vue'),
			meta: {
				title: '团队分析',
				hidden: true
			}
		},
		{
			path: 'todayAnalysis',
			name: 'todayAnalysis',
			component: () => import('@/views/dataAnalysis/todayAnalysis.vue'),
			meta: {
				title: '每日数据'
			}
		},
	]
},
{
	path: '/liveManagement',
	component: Layout,
	name: 'liveManagement',
	meta: {
		title: '直播管理',
		icon: 'material'
	},
	children: [
		{
			path: 'liveRoomManagement',
			name: 'liveRoomManagement',
			component: () => import('@/views/liveManagement/liveRoomManagement/index.vue'),
			meta: {
				title: '直播间管理',
				keepAlive: true
			}
		},
		{
			path: 'shopmanagement',
			name: 'shopmanagement',
			component: () => import('@/views/liveManagement/liveRoomManagement/shopmanagement.vue'),
			meta: {
				title: '商品管理',
				hidden: true,
			}
		},
		{
			path: 'helpactivity',
			name: 'helpactivity',
			component: () => import('@/views/liveManagement/liveRoomManagement/helpactivity.vue'),
			meta: {
				title: '设置助力活动',
				hidden: true,
			}
		},
		{
			path: 'NoputInStorageShop',
			name: 'NoputInStorageShop',
			component: () => import('@/views/liveManagement/NoputInStorageShop.vue'),
			meta: {
				title: '未入库商品',
			}
		},
		{
			path: 'putInStorageShop',
			name: 'putInStorageShop',
			component: () => import('@/views/liveManagement/putInStorageShop.vue'),
			meta: {
				title: '已入库商品',
			}
		},
	]
},
{
	path: '/material',
	component: Layout,
	name: 'p_material',
	meta: {
		title: '素材管理',
		icon: 'material'
	},
	children: [
		// {
		// 	path: 'message-list',
		// 	name: 'Message_List',
		// 	component: () => import('@/views/message/list.vue'),
		// 	meta: {
		// 		title: '资讯管理',
		// 		keepAlive: true
		// 	}
		// }, 
		{
			path: 'message-detail',
			name: 'Message_Detail',
			component: () => import('@/views/message/detail.vue'),
			meta: {
				title: '资讯详情',
				hidden: true
			}
		},
		// {
		// 	path: 'merchants',
		// 	name: 'Material_Merchants',
		// 	component: () => import('@/views/material/merchants.vue'),
		// 	meta: {
		// 		title: '图片/视频素材库',
		// 		keepAlive: true
		// 	}
		// }, 
		{
			path: 'material-info',
			name: 'Material_Info',
			component: () => import('@/views/material/info.vue'),
			meta: {
				title: '素材详情',
				hidden: true
			}
		},
		{
			path: 'material-circle',
			name: 'materialcircle',
			component: () => import('@/views/material/materialcircle.vue'),
			meta: {
				title: '素材圈',
				keepAlive: true
			}
		},
		{
			path: 'material-circleDetail',
			name: 'materialcircleDetail',
			component: () => import('@/views/material/materialcomponents/editmaterial.vue'),
			meta: {
				title: '发圈素材',
				hidden: true
			}
		},
		{
			path: 'groupnotesDetail',
			name: 'groupnotesDetail',
			component: () => import('@/views/material/materialcomponents/editgroupnotes.vue'),
			meta: {
				title: '笔记详情',
				hidden: true
			}
		},
		{
			path: 'checkgrassshow',
			name: 'checkgrassshow',
			component: () => import('@/views/material/materialcomponents/checkgrassshow.vue'),
			meta: {
				title: '审核种草秀',
				hidden: true
			}
		}, {
			path: 'popupadvertising',
			name: 'popupadvertising',
			component: () => import('@/views/material/popupadvertising.vue'),
			meta: {
				title: '弹屏广告'
			}
		},
	]
},
{
	path: '/auth',
	component: Layout,
	name: 'p_auth',
	meta: {
		title: '设置',
		icon: 'lock'
	},
	children: [{
		path: 'roles',
		name: 'Auth_Roles',
		component: () => import('@/views/auth/roles.vue'),
		meta: {
			title: '角色管理'
		}
	}, {
		path: 'employee',
		name: 'Employee_Management',
		component: () => import('@/views/auth/employee.vue'),
		meta: {
			title: '员工管理'
		}
	}, {
		path: 'mallInfo',
		name: 'mallInfo',
		component: () => import('@/views/auth/mallInfo.vue'),
		meta: {
			title: '商城设置'
		}
	}, {
		path: 'decorate',
		name: 'decorate',
		component: () => import('@/views/auth/decorate.vue'),
		meta: {
			title: '首页装修'
		}
	}, {
		path: 'assess',
		name: 'assess',
		component: () => import('@/views/auth/assess.vue'),
		meta: {
			title: '考核配置'
		}
	}, {
		path: 'customerservice',
		name: 'customerservice',
		component: () => import('@/views/auth/customerservice/index.vue'),
		meta: {
			title: '客服管理'
		}
	}, {
		path: 'vipDisposition',
		name: 'vipDisposition',
		component: () => import('@/views/auth/vipDisposition.vue'),
		meta: {
			title: '会员配置'
		}
	}, {
		path: 'qiyuKFManagement',
		name: 'qiyuKFManagement',
		component: () => import('@/views/auth/qiyu/qiyuKFManagement.vue'),
		meta: {
			title: '七鱼客服管理'
		}
	},]
},
{
	path: '/malldecoration',
	component: Layout,
	name: 'p_malldecoration',
	meta: {
		title: '商城装修',
		icon: 'malldecoration'
	},
	children: [
		{
			path: 'specialoccasion',
			name: 'specialoccasion',
			component: () => import('@/views/product/specialoccasion/index.vue'),
			meta: {
				title: '专场系列',
			}
		}, {
			path: 'list',
			name: 'Notice_List',
			component: () => import('@/views/message/notice/list.vue'),
			meta: {
				title: '公告列表',
				// keepAlive: true
			}
		}, {
			path: 'detail',
			name: 'Notice_Detail',
			component: () => import('@/views/message/notice/detail.vue'),
			meta: {
				title: '公告信息',
				hidden: true
			}
		}, {
			path: 'banner',
			name: 'Operation_Banner',
			component: () => import('@/views/operation/banner.vue'),
			meta: {
				title: '轮播图配置',
				// keepAlive: true
			}
		}, {
			path: 'banner-detail',
			name: 'Banner_Detail',
			component: () => import('@/views/operation/banner_detail.vue'),
			meta: {
				title: '轮播图信息',
				hidden: true
			}
		},
		{
			path: 'customizepage',
			name: 'customizepage',
			component: () => import('@/views/malldecoration/customizepage/index.vue'),
			meta: {
				title: '自定义页面'
			}
		},
		{
			path: 'decoration',
			name: 'decoration',
			component: () => import('@/views/malldecoration/customizepage/decoration.vue'),
			meta: {
				title: '自定义页面',
				hidden: true
			}
		}, {
			path: 'liveConfig',
			name: 'liveConfig',
			component: () => import('@/views/malldecoration/liveConfig.vue'),
			meta: {
				title: '直播配置'
			}
		}, {
			path: 'operatedisposition',
			name: 'operatedisposition',
			component: () => import('@/views/malldecoration/operatedisposition/index.vue'),
			meta: {
				title: '运营配置'
			}
		}, {
			path: 'pushmanagement',
			name: 'pushmanagement',
			component: () => import('@/views/malldecoration/pushmanagement/index.vue'),
			meta: {
				title: '推送管理'
			}
		}, {
			path: 'pushmanagementEdit',
			name: 'pushmanagementEdit',
			component: () => import('@/views/malldecoration/pushmanagement/edit.vue'),
			meta: {
				title: '推送信息',
				hidden: true
			}
		}, {
			path: 'pageRelatedConfiguration',
			name: 'pageRelatedConfiguration',
			component: () => import('@/views/malldecoration/pageRelatedConfiguration.vue'),
			meta: {
				title: '页面相关配置',
			}
		},
		{
			path: 'productPicturesTemplate',
			name: 'productImgTemplate',
			component: () => import('@/views/product/product-pictures-template.vue'),
			meta: {
				title: '商品图模板',
			}
		},
		{
			path: 'pageContentConfig',
			name: 'pageContentConfig',
			component: () => import('@/views/malldecoration/pageContentConfig.vue'),
			meta: {
				title: '页面内容配置',
			}
		},
	]
},
{
	path: '/marketing',
	component: Layout,
	name: 'marketing',
	meta: {
		title: '营销管理',
		icon: 'marketing'
	},
	children: [
		{
			path: 'fullsubtraction',
			name: 'fullsubtraction',
			component: () => import('@/views/marketing/fullsubtraction/index.vue'),
			meta: {
				title: '满减活动',
			}
		},
		{
			path: 'fullsubtraction_details',
			name: 'fullsubtraction_details',
			component: () => import('@/views/marketing/fullsubtraction/details.vue'),
			meta: {
				title: '满减活动详情',
				hidden: true,
			}
		},
		{
			path: 'fullsubtraction_datas',
			name: 'fullsubtraction_datas',
			component: () => import('@/views/marketing/fullsubtraction/datas.vue'),
			meta: {
				title: '活动数据',
				hidden: true,
			}
		},
		{
			path: 'signup',
			name: 'signup',
			component: () => import('@/views/marketing/signup/index.vue'),
			meta: {
				title: '报名活动',
				keepAlive: true
			}
		},
		{
			path: 'signup_details',
			name: 'signup_details',
			component: () => import('@/views/marketing/signup/details.vue'),
			meta: {
				title: '报名活动',
				hidden: true,
			}
		},
		{
			path: 'signup_data',
			name: 'signup_data',
			component: () => import('@/views/marketing/signup/data.vue'),
			meta: {
				title: '查看报名信息',
				hidden: true,
			}
		},
		{
			path: 'coupon',
			name: 'coupon',
			component: () => import('@/views/marketing/coupon/index.vue'),
			meta: {
				title: '优惠券',
			}
		},
		{
			path: 'coupon_details',
			name: 'coupon_details',
			component: () => import('@/views/marketing/coupon/details.vue'),
			meta: {
				title: '优惠券',
				hidden: true
			}
		},
		{
			path: 'coupon_condition',
			name: 'coupon_condition',
			component: () => import('@/views/marketing/coupon/condition.vue'),
			meta: {
				title: '优惠券',
				hidden: true
			}
		},
		{
			path: 'coupon_grant',
			name: 'coupon_grant',
			component: () => import('@/views/marketing/coupon/grant.vue'),
			meta: {
				title: '批量发放',
				hidden: true
			}
		},
		{
			path: 'turntable',
			name: 'turntable',
			component: () => import('@/views/marketing/turntable/index.vue'),
			meta: {
				title: '大转盘抽奖',
			}
		},
		{
			path: 'turntableData',
			name: 'turntableData',
			component: () => import('@/views/marketing/turntable/data.vue'),
			meta: {
				title: '大转盘抽奖',
				hidden: true
			}
		},
		{
			path: 'turntableDetails',
			name: 'turntableDetails',
			component: () => import('@/views/marketing/turntable/details.vue'),
			meta: {
				title: '抽奖活动',
				hidden: true
			}
		},
		{
			path: 'payHasGifts',
			name: 'payHasGifts',
			component: () => import('@/views/marketing/payHasGifts/index.vue'),
			meta: {
				title: '支付有礼',
			}
		},
		{
			path: 'payHasGiftsData',
			name: 'payHasGiftsData',
			component: () => import('@/views/marketing/payHasGifts/data.vue'),
			meta: {
				title: '活动数据',
				hidden: true
			}
		},
		{
			path: 'payHasGiftsDetails',
			name: 'payHasGiftsDetails',
			component: () => import('@/views/marketing/payHasGifts/details.vue'),
			meta: {
				title: '支付有礼',
				hidden: true
			}
		},
		{
			path: 'signIn',
			name: 'signIn',
			component: () => import('@/views/marketing/signIn/index.vue'),
			meta: {
				title: '签到活动',
			}
		},
		{
			path: 'signInDetails',
			name: 'signInDetails',
			component: () => import('@/views/marketing/signIn/details.vue'),
			meta: {
				title: '签到活动',
				hidden: true
			}
		},
		{
			path: 'signInData',
			name: 'signInData',
			component: () => import('@/views/marketing/signIn/data.vue'),
			meta: {
				title: '活动数据',
				hidden: true
			}
		},
		{
			path: 'TaskReward',
			name: 'TaskReward',
			component: () => import('@/views/marketing/TaskReward/index.vue'),
			meta: {
				title: '任务奖励活动',
			}
		},
		{
			path: 'TaskRewardDetails',
			name: 'TaskRewardDetails',
			component: () => import('@/views/marketing/TaskReward/details.vue'),
			meta: {
				title: '任务奖励活动',
				hidden: true
			}
		},
		{
			path: 'TaskRewardData',
			name: 'TaskRewardData',
			component: () => import('@/views/marketing/TaskReward/data.vue'),
			meta: {
				title: '活动数据',
				hidden: true
			}
		},
		{
			path: 'tradeInActivity',
			name: 'tradeInActivity',
			component: () => import('@/views/marketing/tradeInActivity/index.vue'),
			meta: {
				title: '换购活动',
			}
		},
		{
			path: 'tradeInActivityDetails',
			name: 'tradeInActivityDetails',
			component: () => import('@/views/marketing/tradeInActivity/details.vue'),
			meta: {
				title: '换购活动',
				hidden: true
			}
		},
		{
			path: 'tradeInActivityData',
			name: 'tradeInActivityData',
			component: () => import('@/views/marketing/tradeInActivity/data.vue'),
			meta: {
				title: '活动数据',
				hidden: true
			}
		},
		{
			path: 'inviteFriend',
			name: 'inviteFriend',
			component: () => import('@/views/marketing/inviteFriend/index.vue'),
			meta: {
				title: '邀友有礼',
			}
		},
		{
			path: 'inviteFriendDetails',
			name: 'inviteFriendDetails',
			component: () => import('@/views/marketing/inviteFriend/details.vue'),
			meta: {
				title: '邀友有礼',
				hidden: true
			}
		},
		{
			path: 'inviteFriendData',
			name: 'inviteFriendData',
			component: () => import('@/views/marketing/inviteFriend/data.vue'),
			meta: {
				title: '邀友有礼',
				hidden: true
			}
		},
		{
			path: 'fixedPrice',
			name: 'fixedPrice',
			component: () => import('@/views/marketing/fixedPrice/fixedPrice.vue'),
			meta: {
				title: '随心选'
			}
		},
		{
			path: 'fixedPriceData',
			name: 'fixedPriceData',
			component: () => import('@/views/marketing/fixedPrice/fixedPriceData.vue'),
			meta: {
				title: '随心选',
				hidden: true
			}
		},
		{
			path: 'fixedPriceDetails',
			name: 'fixedPriceDetails',
			component: () => import('@/views/marketing/fixedPrice/fixedPriceDetails.vue'),
			meta: {
				title: '随心选',
				hidden: true
			}
		},
		{
			path: 'koiRaffle',
			name: 'koiRaffle',
			component: () => import('@/views/marketing/koiRaffle/koiRaffle.vue'),
			meta: {
				title: '锦鲤抽奖'
			}
		},
		{
			path: 'koiRaffleData',
			name: 'koiRaffleData',
			component: () => import('@/views/marketing/koiRaffle/koiRaffleData.vue'),
			meta: {
				title: '锦鲤抽奖',
				hidden: true
			}
		},
		{
			path: 'koiRaffleDetails',
			name: 'koiRaffleDetails',
			component: () => import('@/views/marketing/koiRaffle/koiRaffleDetails.vue'),
			meta: {
				title: '锦鲤抽奖',
				hidden: true
			}
		},
	]
}, {
	path: '/toBApp',
	component: Layout,
	name: 'toBApp',
	meta: {
		title: 'B端APP业务',
		icon: 'tobapp'
	},
	children: [
		{
			path: 'productRecommend',
			name: 'productRecommend',
			component: () => import('@/views/toBApp/productRecommend.vue'),
			meta: {
				title: '商品推荐',
			}
		},
		{
			path: 'operationLog',
			name: 'operationLog',
			component: () => import('@/views/toBApp/operationLog.vue'),
			meta: {
				title: '操作日志',
			}
		},
		{
			path: 'employeeAccount',
			name: 'employeeAccount',
			component: () => import('@/views/toBApp/employeeAccount.vue'),
			meta: {
				title: '运营者管理',
			}
		},
		{
			path: 'employeeAccountEdit',
			name: 'employeeAccountEdit',
			component: () => import('@/views/toBApp/employeeAccountEdit.vue'),
			meta: {
				title: 'B端APP运营者配置',
				hidden: true
			}
		},
		{
			path: 'PKRanking',
			name: 'PKRanking',
			component: () => import('@/views/toBApp/PKRanking/list.vue'),
			meta: {
				title: 'PK榜活动',
			}
		},
		{
			path: 'PKRankingDetails',
			name: 'PKRankingDetails',
			component: () => import('@/views/toBApp/PKRanking/details.vue'),
			meta: {
				title: 'PK榜活动',
				hidden: true
			}
		},
	]
}, {
	path: '/goJianXi',
	component: Layout,
	name: 'goJianXi',
	meta: {
		title: '前往简熙后台',
		icon: 'home',
	},
	children: [{
		path: 'goJianXi',
		name: 'goJianXi',
		component: () => import('@/views/nothing/nothing.vue'),
		meta: {
			title: '前往简熙后台',
			icon: 'home',
			type: 'single'
		}
	}]
},
]

const createRouter = () => new VueRouter({
	// 切换页面保存滚动条定位
	scrollBehavior: (to: any, from: any, savedPosition: any) => {
		// console.log(savedPosition,'savedPosition')
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	routes: constantRoutes
})


const router = createRouter();
// router.afterEach( route => {
// 	window.scrollTo(0,0)
// })
export default router;
